export const STATUS_LABELS = {
  pendente: "Pendente",
  em_analise: "Em análise",
  aprovado: "Aprovado",
  pago: "Pago",
  rejeitado: "Rejeitado",
};

export default function StatusBadge({ status }) {
  const label = STATUS_LABELS[status] || status;
  return (
    <span className={`badge-status badge-${status}`} data-testid={`status-badge-${status}`}>
      {label}
    </span>
  );
}
